/** Codici stato richiesta nuovo invio restituiti dal backend (`codiStato`). */
export enum CodiStatoRichiestaEnum {
  EVASA = 'EVASA',
  NON_EVASA = 'NON_EVASA',
  IN_EVASIONE = 'IN_EVASIONE',
}

/** Id di `GET stati-richiesta`, usati dal filtro come `sequStato`. */
export enum SequStatoRichiestaEnum {
  EVASA = 1,
  NON_EVASA = 2,
  IN_EVASIONE = 3,
}

export function normalizeCodiStatoRichiesta(value: string | null | undefined): string {
  return (value ?? '').trim().toUpperCase();
}

export function isCodiStatoRichiestaEvasa(value: string | null | undefined): boolean {
  return normalizeCodiStatoRichiesta(value) === CodiStatoRichiestaEnum.EVASA;
}

export function isCodiStatoRichiestaNonEvasa(value: string | null | undefined): boolean {
  return normalizeCodiStatoRichiesta(value) === CodiStatoRichiestaEnum.NON_EVASA;
}

export function isCodiStatoRichiestaInEvasione(value: string | null | undefined): boolean {
  return normalizeCodiStatoRichiesta(value) === CodiStatoRichiestaEnum.IN_EVASIONE;
}
